import { useAuth } from "@clerk/react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();

  // Clerk is still initialising — render nothing to avoid flash
  if (!isLoaded) return null;

  // Not signed in — send to landing page
  if (!isSignedIn) return <Navigate to="/landing" replace />;

  return children;
};

export default ProtectedRoute;
